import Line from './Line';
import styles from './Timeline.module.scss';

const Timeline = ({ items = [] }) => (
  <div className={styles.timeline}>
    <ol>
      {items.map((item) => (
        <Line key={item._uid} year={item.year} text={item.text} />
      ))}
    </ol>
  </div>
);

export default Timeline;
